module.exports = __webpack_public_path__ + "static/media/53.60d4255c.png";